module.exports = __webpack_public_path__ + "img/zk.72eb4f40.svg";